import { ReactElement, useEffect, useLayoutEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import globalRouter from '../_helpers/globalRouter';
import { useData } from '../context/data.context';
import AuthHeader from './AccountActivation/header';

const STEPS = [
  {
    label: 'Add Devices',
    path: '/onboarding/add-devices'
  },
  {
    label: 'Connect to internet',
    path: '/onboarding/connect-internet'
  },
  {
    label: 'Configure devices',
    path: '/onboarding/configure-devices'
  },
  {
    label: 'Add groups',
    path: '/onboarding/add-groups'
  },
  {
    label: 'Invite users',
    path: '/onboarding/invite-users'
  }
];

/**
 * A Layout Component that's a combination of navbar and sidebar.
 * @returns - React element that represents the layout component.
 */
export default function Layout(): ReactElement {
  const navigate = useNavigate();
  const { userConfigData } = useData();
  const location = useLocation();
  globalRouter.navigate = navigate;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [headerheight, setHeaderHeight] = useState(0);
  /**
   * Function to handle event resize.
   */
  const handleResize = (): void => {
    const element = document.querySelector('header');
    const rect = element?.getBoundingClientRect();
    if (rect?.height) {
      setHeaderHeight(rect.height);
    }
  };
  useLayoutEffect(() => {
    handleResize();
  }, [userConfigData.username]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex flex-col h-screen">
      <AuthHeader />
      <div className="flex flex-1">
        <div className="w-60 bg-background-700 p-6  gap-4 flex flex-col">
          {STEPS.map((step, index) => {
            const isSelected = step.path === location.pathname;
            const isBefore = STEPS.findIndex((s) => s.path === location.pathname) < index;
            return (
              <Link
                className={`flex items-center gap-2 ${
                  // eslint-disable-next-line no-nested-ternary
                  isSelected
                    ? 'text-primary-500'
                    : isBefore
                    ? 'text-background-300'
                    : 'text-gray-300'
                }`}
                key={step.path}
                to={step.path}
              >
                <div className="flex items-center gap-2 justify-center rounded-full p-1 border-2 bg-[rgba(255,255,255,0.05)] border-[rgba(255,255,255,0.05)] h-6 w-6">
                  {isSelected && (
                    <div className="flex items-center justify-center bg-primary-500 border-2 border-primary-500 rounded-full h-full w-full" />
                  )}
                  {!isBefore && !isSelected && (
                    <div className="material-icons-outlined text-white text-xs">check</div>
                  )}
                </div>
                <div className="text-sm">{step.label}</div>
              </Link>
            );
          })}
        </div>
        <div className="flex flex-col flex-1 box-border justify-center items-center p-6 py-16">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
